<div class="tab-pane" uib-tab-content-transclude="tab">
  <app-dealer-profile [profile]="profile"></app-dealer-profile>
  <strong class="profileNotice text-danger">If this information needs to be updated, please contact
    DLNR: Dina at (808) 587-0088 or Nikky at (808) 587-0564, Monday – Friday, 8:00 AM – 4:00 PM, or email
    DealerReport@hawaii.gov</strong>
  <button *ngIf="!loading" type="button" (click)="resetPassword()" class="btn btn-primary btn-sm"><i class="fas fa-key"> </i> Request Password
    Change
  </button>
  <i *ngIf="loading" class="fa fa-spinner fa-spin"></i>

</div>
